<template>
  <div class="SvgTableFooter">
    <!-- <div class="button"
      :class="{inactive: tableStart}"
      @click="showSvgTable(-1)">
      <img class="reversed" src="../assets/aic_button.svg">
    </div> -->
    <div class="footnav">
      <span v-if="at != 0 && pages != 0">{{ at }} / {{ pages }}</span>
      <div class="footnav-container">
        <button
          v-if="preId !== null"
          class="nav-button"
          :disabled="!preId"
          @click.prevent="goToId(preId)"
        >前の発注コードへ</button>
        <router-link class="style-button" :to="{name: 'SelectItem'}">発注コード検索へ戻る</router-link>
        <button
          v-if="nextId !== null"
          class="nav-button"
          :disabled="!nextId"
          @click.prevent="goToId(nextId)"
        >次の発注コードへ</button>
      </div>
    </div>
    <!-- <div class="button"
      :class="{inactive: tableEnd}"
      @click="showSvgTable(1)">
      <img src="../assets/aic_button.svg">
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'SvgTableFooter',
  props: {
    at: {
      type: Number,
      default: 0
    },
    pages: {
      type: Number,
      default: 0
    },
    preId: {
      type: String,
      required: false,
      default: null
    },
    nextId: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    tableStart () {
      return this.at === 1
    },
    tableEnd () {
      return this.at === this.pages
    }
  },
  methods: {
    showSvgTable (n) {
      const nextAt = this.at + n
      if (nextAt > 0 && this.pages >= nextAt) {
        // let q = Object.keys(this.query).reduce((str, key) => {
        //   return key !== 'at' ? str + `${key}=${this.query[key]}&` : str
        // }, '?')
        // q += `at=${nextAt}`
        // window.location.search = q
        this.$router.replace({params: {at: nextAt}})
      }
    },
    goToId (id) {
      this.$router.push({params: {
        itemId: id.substr(1)
      }})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.SvgTableFooter {
  /* display: table;
  border-collapse: separate;
  border-spacing: 0 0; */
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 90%;
  height: 100%;
  justify-content: center;
}
.SvgTableFooter .button {
  display: block;
  position: relative;
  width: 42px;
  border-radius: 50%;
  /* border: 1.5px solid #fff; */
  background-color: #fff;
  transition: all .1s;
}
/* .SvgTableFooter .button:hover :not(.inactive) {
  opacity: 0.7;
} */
.SvgTableFooter .button:active :not(.inactive) {
  opacity: 0.4;
}
.SvgTableFooter .button > img {
  width: 42px;
  touch-action: manipulation;
}
.SvgTableFooter .button > img.reversed {
  transform: rotate(180deg);
}
.SvgTableFooter .footnav {
  display: block;
  width: 100%;
  font-size: 0.85rem;
  /* line-height: 1.05; */
}
.SvgTableFooter .footnav .footnav-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footnav .style-button {
  display: inline-block;
  margin: 2px 8px;
  padding: 2px 4px;
  /* height: 18px; */
  font-size: 0.75rem;
  font-weight: 500;
  /* line-height: 18px; */
  vertical-align: middle;
  text-decoration: none;
  border-radius: 2px;
}
.footnav .nav-button {
  padding: 2px 8px;
  width: 6em;
  font-size: 12px;
  line-height: 1.2;
  background-color: #eee;
  border: none;
}
.footnav {
  display: flex;
  flex-flow: column nowrap;
}
.footnav > span {
  display: block;
}
.footnav .router-link-active {
  color: #2c3e50;
  background-color: #fff;
}
.inactive {
  opacity: 0.4;
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/SvgTableFooter.vue